define('collections/payment/team-payments',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models
    'models/payment/team-payment'
], function(
    // libs
    _, Backbone, U, API,
    // model
    MTeamPayment
) {

    var CTeamPayments = Backbone.Collection.extend({
        url: API.url("payments/team/"),
        model: MTeamPayment,

        initialize: function(models, opt) {
            this.readyPromise = Backbone.$.Deferred();
        },

        parse: function(data, opt) {
            return CTeamPayments.__super__.parse.call(this, data, opt);
        },

        ready: function() {
            return this.readyPromise;
        }
    });

    return CTeamPayments;
});

